














































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import VueScrollTo from "vue-scrollto"; 
import { ITreeList } from "./types";
import { isFunction, isMobile } from "@/common/utils";

let GUID:number = 0;
@Component({
  name: 'v-tree-list'
})
export default class extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  }) items: ITreeList[];
  @Prop({
    default: true
  }) showDivider: boolean;
  @Prop({
    default: true
  }) showLegend: boolean;
  @Prop({
    default: false
  }) dense : boolean;
  @Prop({
    default: () => { return 0; }
  }) depth: number;
  @Prop({
    default: 0
  }) indent: number;

  mounted() {
  }

  beforeDestroy() {
  }

  get isMobile() : boolean {
    return isMobile();
  }

  get User() {
    return this.$store.getters.User;
  }

  get language() : string {
    return this.User.Language;
  }

  get guid() : number {
    return ++GUID;
  }

  get myId() : string {
    let parent:ITreeList = null;
    if (this.items && this.items.length>0) {
      parent = this.items[0].parent;
    }
    if (!parent) {
      return 'vtreelist-root-' + this.guid;
    } else {
      return 'vtreelist-children-' + (parent.id || this.guid);
    }
  }

  itemId(item) : string {
    item.id = this.guid + '';
    return item.id;
  }

  iconButton(text:string) : boolean {
    console.log("iconButton: " + !text);
    return !text;
  }
  
  hasChildren(item:ITreeList) : boolean {
    return (item.children && item.children.length>0) ||
           (this.showLegend && item.legend && item.legend.length>0);
  }
  
  hasMapSource(item:ITreeList) : boolean {
    return item.mapSources && item.mapSources.length>0;
  }

  hasStyle(item:ITreeList) : boolean {
    //return !!item.style || !!item.icons || !!item.image || !!item.className;
    let hasStyle:boolean = false;
    let i;
    for (i=0; i<this.items.length; i++) {
      let item = this.items[i];
      if (!!item.style || !!item.icons || !!item.image || !!item.className) {
        hasStyle = true;
        break;
      }
    }
    return hasStyle;
  }

  itemStyle(item:ITreeList) : {[key:string] : any} {
    // IMPORTANT: set min and max width, style may be shrinked due to long title
    /*return Object.assign({
      'min-width': ICON_SIZE, //'20px',
      'max-width': ICON_SIZE, //'20px',
      height: item.image && !item.image.match(/\.svg$/i) ? ICON_SIZE : ICON_SIZE2, //'20px' : '16px',
      'margin-right': '8px'
    }, item.style || {});*/
    return item.style || {};
  }

  itemClass(item:ITreeList) : string {
    let c = 'v-tree-item__style';
    c += item.className ? (' ' + item.className) : '';
    c += (item.image && item.image.match(/\.svg$/i)) ? ' svg-image' : '';
    return c;
  }

  isChecked(item) : boolean {
    return item.checked;
  }

  checkOrRadioIcon(item:ITreeList) : string {
    let icon;
    if (item.checked!==false) {
      icon = item.iconChecked || (
        item.type=='checkbox' ? item.checked=='indeterminate' ? 'mdi-checkbox-intermediate' : 'mdi-checkbox-marked' 
        : 'mdi-radiobox-marked'
      );
    } else {
      icon = item.iconUnChecked || (
        item.type=='checkbox' ? 'mdi-checkbox-blank-outline' : 'mdi-radiobox-blank'
      );
    }
    return icon;
  }

  get SubTreeIndent() : number {
    let INDENT = this.dense ? 28 : 24;
    let i,indent:number = this.depth===0 ? INDENT : 0; //this.indent;
    let hasStyle: boolean = false;
    for (i=0; i<this.items.length; i++) {
      if (this.hasStyle(this.items[i])) {
        indent = INDENT; // (20 width + 8 margin-right) refer to this.item.Style()
        hasStyle = true;
        break;
      }
    };
    /*if (!hasStyle && !indent) {
      indent = 12;
    }*/
    return indent;
  }

  updateParent(item:ITreeList) {
    let checked:boolean | "indeterminate" = item.children[0].checked;
    item.children.forEach((child) => {
      if (child.checked!==checked) {
        checked = 'indeterminate';
        return;
      }
    });
    if (item.type && item.checked!==checked) {
      item.checked = checked;
      item.visible = !!item.checked;
    //} else if (item.mapSources) {
    //  item.visible = !!checked;
    }
    if (item.parent) {
      this.updateParent(item.parent);
    }
  }

  updateChild(children:ITreeList[], checked:boolean | "indeterminate") {
    children.forEach((item) => {
      if (item.mapSources && item.type && item.checked!==checked) {
        item.checked = checked;
        item.visible = !!item.checked;
      }
      if (item.children && item.children.length>0) {
        this.updateChild(item.children, checked);
      } else if (item.legend && item.legend.length>0) {
        this.updateChild(item.legend, checked);
      }
    }, this);
  }

  onActionSelectionChange(item, action) {
    let selection = null;
    for (let i=0; i<action.options.length && !selection; i++) {
      if (action.options[i].value==action.selected) {
        selection = action.options[i];
      }
    }
    if (isFunction(action.do)) {
      action.do.call(item, selection);
    } else {
      this.$emit('action', {item:item, action:{
        action: 'changeActionSelection',
        selection: selection
      }});
    }
  }

  doAction(item, action) {
    if (action.action=='changeChecked') {
      item.checked = !item.checked;
      item.visible = !!item.checked;
      if (this.hasMapSource(item)) {
        item.mapSources.forEach((ms) => {
          ms.visible = item.checked;
          if (ms.nativeLayer) {
            if (isFunction(item.setVisibility)) {
              item.setVisibility.call(item, ms.visible);
            } else {
              ms.nativeLayer.setVisible(ms.visible);
            }
          }
        });
      }
      if (item.parent) {
        this.updateParent(item.parent);
      }
      if (item.children && item.children.length>0) {
        this.updateChild(item.children, item.checked);
      } else if (item.legend && item.legend.length>0) {
        this.updateChild(item.legend, item.checked);
      }
    }
    if (isFunction(action.do)) {
      action.do(item);
    } else if (isFunction(item.doAction)) {
      item.doAction({item:item, action:action});
    } else {
      this.$emit('action',{item:item, action:action});
    }
    /* ISSUE: it scrolls to but not accurately
    if (action.scrollTo) {
      setTimeout(() => {
        this.scrollTo(action.scrollTo);
      }, 400);
    }*/
  }

  scrollTo(toId:string) {
    // ISSUE: it scrolls to but not accurately
    let container = this.$el;
    while (!(container.id && container.id.match(/^vtreelist-root-/))) {
      container = container.parentElement;
    }
    if (container) {
      container = container.parentElement;
      VueScrollTo.scrollTo('#' + toId); //, 300, {container:container});
    }
  }
}
